import styled from 'styled-components/macro';

export const SelectWrapper = styled.div`
  width: 100%;
  position: relative;
`;
